import {useRef, useEffect, useCallback} from 'react';
import {Platform} from 'react-native';
import {useSelector} from 'react-redux';
import PlatformWorld from 'components/World/PlatformWorld';
import {COMMAND_ROUTE} from 'utils/World/config';

/**
 * Mirrors the web branch of `World.onLevelLoadComplete` after Unity sends legacy route `x`
 * (level finished loading). Without this, the scene can stay on a default camera (e.g. sky only).
 */
export function useLessonViewerUnityOnLegacyMessage(locationFolder) {
  const initDone = useRef(false);
  const legacy = useSelector(s => s.meeting.meeting.legacy);
  const directLanding = useSelector(s => s.meeting.meeting.direct_landing);
  const newAvatarUrl = useSelector(s => s.meeting.meeting.avatarUrlValue ?? '');

  useEffect(() => {
    initDone.current = false;
  }, [locationFolder]);

  return useCallback(
    message => {
      if (Platform.OS !== 'web') {
        return;
      }
      if (!message || message.route !== 'x') {
        return;
      }
      if (initDone.current) {
        return;
      }
      initDone.current = true;

      const locFilter = locationFolder;

      PlatformWorld.sendMessage({
        route: COMMAND_ROUTE,
        payload: `set_location_filter ${locFilter}`,
      });
      PlatformWorld.sendMessage({
        route: COMMAND_ROUTE,
        payload: 'finish_loading',
      });
      PlatformWorld.sendMessage({route: COMMAND_ROUTE, payload: 'after_join'});
      PlatformWorld.sendMessage({
        route: COMMAND_ROUTE,
        payload: 'show_names false',
      });
      PlatformWorld.sendMessage({
        route: COMMAND_ROUTE,
        payload: 'show_chat false',
      });
      PlatformWorld.sendMessage({
        route: COMMAND_ROUTE,
        payload: 'set_quality HIGH',
      });
      PlatformWorld.sendMessage({
        route: COMMAND_ROUTE,
        payload: 'set_fps_limit 30',
      });
      PlatformWorld.sendMessage({
        route: COMMAND_ROUTE,
        payload: `set_legacy ${legacy}`,
      });
      PlatformWorld.sendMessage({
        route: COMMAND_ROUTE,
        payload: `direct_landing ${directLanding}`,
      });
      PlatformWorld.sendMessage({
        route: COMMAND_ROUTE,
        payload: `set_avatar_url ${newAvatarUrl} ${directLanding}`,
      });
    },
    [locationFolder, legacy, directLanding, newAvatarUrl],
  );
}
